module.exports = __webpack_public_path__ + "img/img97.e50bfff5.svg";